<template>
  <v-container fluid class="pa-0 mo-bg" style="min-height: 87vh">
    <v-row class="ma-0 pa-0" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="7">
        <v-sheet
          class="mo-panel neo-surface elevation-3 rounded-xl mx-auto"
          max-width="820"
        >
          <v-toolbar flat dense class="mo-toolbar">
            <v-btn icon small class="white--text mr-1" @click="goBack">
              <v-icon color="white" small>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text d-flex align-center">
              <v-icon left color="white" class="mr-2">mdi-qrcode-scan</v-icon>
              Cari Form Pallet
            </v-toolbar-title>
          </v-toolbar>
          <div class="position-relative">
            <canvas ref="bgCanvas" class="bg-canvas"></canvas>
            <div class="pa-6 neo-surface">
              <div v-if="step === 'scan_pallet'">
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      class="neo-input"
                      v-model="palletFormNo"
                      label="Scan/Tempel Nomor Form Pallet"
                      prepend-inner-icon="mdi-numeric"
                      append-outer-icon="mdi-qrcode-scan"
                      @click:append-outer="openScanPallet"
                      clearable
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-2" dense>
                  <v-col cols="12">
                    <v-progress-linear
                      v-if="searching"
                      indeterminate
                      color="primary"
                      height="4"
                      rounded
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-2" dense>
                  <v-col cols="12">
                    <v-btn
                      block
                      class="neo-btn"
                      :disabled="!palletFormNo || searching"
                      @click="goToPalletDetail"
                    >
                      <v-icon left>mdi-magnify</v-icon>
                      Cari
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </v-sheet>
      </v-col>
    </v-row>

    <production-scanner
      v-model="dialogScanPallet"
      title="Scan Form Pallet"
      input-label="Scan/Tempel Nomor Form Pallet"
      :action-label="'Cari'"
      :persistent="false"
      :auto-close-on-scan="true"
      :auto-emit-on-scan="true"
      @scanned="handlePalletScanned"
    />
  </v-container>
</template>

<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
import { mapMutations } from 'vuex'

export default {
  name: 'SpreadLoading',
  components: {
    ProductionScanner: () =>
      import('../../../home/components/ProductionScanner.vue')
  },
  data() {
    return {
      passedApi: buildType.apiURL('passed'),
      step: 'scan_pallet',
      palletFormNo: '',
      dialogScanPallet: false,
      searching: false
    }
  },
  methods: {
    ...mapMutations(['setPassetDetail']),
    goBack() {
      if (this.$router) this.$router.back()
    },
    openScanPallet() {
      this.dialogScanPallet = true
    },
    handlePalletScanned(code) {
      this.palletFormNo = (code || '').toString().trim()
    },
    async goToPalletDetail() {
      const palletNo = (this.palletFormNo || '').toString().trim()
      if (!palletNo || this.searching) return

      this.palletFormNo = palletNo
      this.searching = true

      const url = `${this.passedApi}palletorder/detail/${encodeURIComponent(
        palletNo
      )}`

      try {
        const response = await axios.get(url)
        const payload = response && response.data
        if (payload && payload.status_code === '00' && payload.data) {
          this.setPassetDetail(payload.data)
          this.$router &&
            this.$router.push({
              name: 'lotCheckerSpreadPalletDetail',
              query: { no: palletNo }
            })
        } else {
          const message =
            (payload && payload.status_msg) || 'Data tidak ditemukan'
          this.$swal && this.$swal.fire('Info', message, 'warning')
        }
      } catch (error) {
        console.error('goToPalletDetail error', error)
        this.$swal &&
          this.$swal.fire('Error', 'Gagal mengambil detail pallet', 'error')
      } finally {
        this.searching = false
      }
    },
    drawBackground() {
      const canvas = this.$refs.bgCanvas
      if (!canvas) return
      const container = canvas.parentElement
      const w = container.clientWidth
      const h = 220
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, w, h)
      const g1 = ctx.createRadialGradient(
        w * 0.25,
        h * 0.5,
        10,
        w * 0.25,
        h * 0.5,
        170
      )
      g1.addColorStop(0, 'rgba(144, 202, 249, 0.35)')
      g1.addColorStop(1, 'rgba(144, 202, 249, 0)')
      ctx.fillStyle = g1
      ctx.beginPath()
      ctx.arc(w * 0.25, h * 0.55, 150, 0, Math.PI * 2)
      ctx.fill()
      const g2 = ctx.createRadialGradient(
        w * 0.8,
        h * 0.2,
        10,
        w * 0.8,
        h * 0.2,
        150
      )
      g2.addColorStop(0, 'rgba(165, 214, 167, 0.35)')
      g2.addColorStop(1, 'rgba(165, 214, 167, 0)')
      ctx.fillStyle = g2
      ctx.beginPath()
      ctx.arc(w * 0.8, h * 0.25, 140, 0, Math.PI * 2)
      ctx.fill()
    }
  },
  mounted() {
    this.$nextTick(() => this.drawBackground())
    window.addEventListener('resize', this.drawBackground)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawBackground)
  }
}
</script>

<style scoped>
.mo-toolbar {
  background: linear-gradient(135deg, #90caf9 0%, #a5d6a7 100%);
}
.mo-bg {
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 70%);
}
.mo-panel {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}
.bg-canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  pointer-events: none;
}
.neo-surface {
  --bg: #f3f6fb;
  background: var(--bg) !important;
}
.neo-input /deep/ .v-input__slot,
.neo-input >>> .v-input__slot {
  background: var(--bg);
  border-radius: 9999px !important;
  border: none !important;
  box-shadow: inset 3px 3px 6px rgba(0, 0, 0, 0.1),
    inset -3px -3px 6px rgba(255, 255, 255, 0.95) !important;
  padding-left: 14px !important;
}
.neo-input /deep/ fieldset,
.neo-input >>> fieldset {
  border: 0 !important;
}
.neo-input /deep/ .v-text-field__details,
.neo-input >>> .v-text-field__details {
  display: none;
}
.neo-input /deep/ .v-input__prepend-inner .v-icon,
.neo-input >>> .v-input__prepend-inner .v-icon {
  color: #9aa4b2 !important;
}
.neo-input.v-input--is-focused /deep/ .v-input__slot,
.neo-input.v-input--is-focused >>> .v-input__slot {
  box-shadow: inset 4px 4px 8px rgba(0, 0, 0, 0.12),
    inset -4px -4px 8px rgba(255, 255, 255, 0.98) !important;
}
.value {
  color: #263238;
}

.neo-btn.v-btn {
  --bg: #f3f6fb;
  --hi: rgba(255, 255, 255, 0.95);
  background: var(--bg) !important;
  color: #263238 !important;
  border-radius: 14px !important;
  padding: 10px 16px !important;
  text-transform: none;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.08), -8px -8px 16px var(--hi) !important;
}
.neo-btn.v-btn::before {
  background-color: transparent !important;
}
.back-btn {
  padding-left: 12px !important;
  padding-right: 14px !important;
}
</style>
